
import { Component, Prop, Vue } from 'vue-property-decorator';


import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");
import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { stepsAndPagesNumberInfoType } from '@/types/Application/StepsAndPages';
import moment from 'moment';
import { courtLocationInfoType } from '@/types/Common';
import { stepInfoType } from '@/types/Application';


@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class FormP1 extends Vue {    

    @Prop({required:false, default:false})
    exhibit!: boolean
    
    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public steps!: stepInfoType[]; 

    @applicationState.State
    public deceasedName!: string;

    @applicationState.State
    public applicantName!: string;

    @applicationState.State
    public applicationLocation!: courtLocationInfoType;

    grantType = "Grant of Administration Without Will Annexed";

    courtName = '';
    deceasedDateOfDeath ='';  
    deceasedAddress = {};
    applicantMailingAddress = {};
    applicantServiceAddress = {};
    applicantServiceEmail = '';
    applicantServicePhone = '';
    currentDate = '';

    dataReady=false

    public getFormData() {

        this.courtName = this.applicationLocation.name??''

        //___Deceased        
        const deceasedInfo = this.steps[this.stPgNo.DECEASED._StepNo].result?.informationAboutDeceasedSurvey?.data;
        this.deceasedDateOfDeath = deceasedInfo?.deceasedDateOfDeath;
        this.deceasedAddress = deceasedInfo?.deceasedAddress??{};

        //___Applicant
        const applicantInfo = this.steps[this.stPgNo.APPLICANT._StepNo].result?.applicantInfoSurvey?.data;
        this.applicantMailingAddress = applicantInfo?.applicantMailingAddress && applicantInfo?.applicantOrdinaryAddressReceiveMail=='y'?
            applicantInfo?.applicantMailingAddress : (applicantInfo?.applicantOrdinaryAddress??{})

        //___Service
        const serviceInfo = this.steps[this.stPgNo.APPLICANT._StepNo].result?.applicantServiceSurvey?.data;       
        this.applicantServiceAddress = serviceInfo?.applicantServiceAddress??{}        
        
        this.applicantServiceEmail = serviceInfo?.applicantServiceEmail??'';
        this.applicantServicePhone = serviceInfo?.applicantServicePhone??''; 
    }

    mounted(){ 
        this.dataReady=false
        this.currentDate = moment().format("MMMM DD, yyyy")
        this.getFormData();
        this.dataReady=true
        Vue.nextTick(() => this.onPrint(false));
    }

    public onPrint(openDownload) {        
        const el= document.getElementById("print");
        // console.log(el)
        const body = Vue.filter('printPdf')(el.innerHTML,`"Generated by “Representation Grant” on ${this.currentDate}.         "`,`"P1 "`);
        this.$emit('onPrint',body,openDownload)
    }

}
